(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gift-guide-session-shuffle"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);
  const hasFilter = Array.from(params.keys()).some((key) => key.startsWith("filter."));
  const grid = document.getElementById("product-grid");

  if (!grid) return;

  const cards = Array.from(
    grid.querySelectorAll(":scope > li.column:not(.promotion-column):not(.loading-overlay)")
  );

  grid.dataset.giftGuideGrid = "true";

  cards.forEach((card) => {
    const productLink = card.querySelector("a[href*=\"/products/\"]");
    if (!productLink) return;

    const productPath = new URL(productLink.href, window.location.origin).pathname;
    const productHandle = productPath.split("/products/")[1];

    if (productHandle) card.dataset.productHandle = productHandle;
  });

  if (params.has("sort_by") || params.has("page") || hasFilter) return;

  const completeRowCount = Math.floor(cards.length / 3);

  if (completeRowCount < 2) return;

  const rows = Array.from(
    { length: completeRowCount },
    (_, rowIndex) => cards.slice(rowIndex * 3, rowIndex * 3 + 3)
  );
  const remainder = cards.slice(completeRowCount * 3);
  const signatures = rows.map((row) =>
    row
      .map((card) => {
        const productLink = card.querySelector("a[href*=\"/products/\"]");
        return productLink ? productLink.getAttribute("href") : card.textContent.trim();
      })
      .join("|")
  );
  const storageKey = "style-shack-gift-guide-row-order-v1";
  let rowOrder;

  try {
    const savedOrder = JSON.parse(window.sessionStorage.getItem(storageKey) || "null");
    const isCurrentOrder =
      Array.isArray(savedOrder) &&
      savedOrder.length === signatures.length &&
      savedOrder.every((signature) => signatures.includes(signature));

    if (isCurrentOrder) rowOrder = savedOrder;
  } catch (error) {
    rowOrder = null;
  }

  if (!rowOrder) {
    rowOrder = [...signatures];

    for (let index = rowOrder.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(Math.random() * (index + 1));
      [rowOrder[index], rowOrder[swapIndex]] = [rowOrder[swapIndex], rowOrder[index]];
    }

    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(rowOrder));
    } catch (error) {
      rowOrder = [...signatures];
    }
  }

  const rowsBySignature = new Map(
    rows.map((row, rowIndex) => [signatures[rowIndex], row])
  );
  const loadingOverlay = grid.querySelector(":scope > .loading-overlay");
  const reorderedCards = rowOrder
    .flatMap((signature) => rowsBySignature.get(signature) || [])
    .concat(remainder);

  reorderedCards.forEach((card) => {
    grid.insertBefore(card, loadingOverlay);
  });
});
  } catch(e) { console.error(e); }
})();

})();
